//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/importAccount/views/main/lan/es';
import sourceMigration from 'Modules/importAccount/views/main/.components/sourceMigration/lan/es';
import newMigration from 'Modules/importAccount/views/main/.components/newMigration/lan/es';
import exceptionDetails from 'Modules/importAccount/views/main/.components/exceptionDetails/lan/es';

locales = {
    ...locales,
    ...main,
    ...sourceMigration,
    ...newMigration,
    ...exceptionDetails,
};

export default locales;